<template>
  <div>
    <Head title="Teams" />
    <div class="flex justify-between flex-wrap">
      <h1 class="flex items-center mb-8 text-orfBlue-100 text-3xl font-bold">
        <HeroIcon name="flag" class="mr-2 w-10 h-10 fill-orfBlue-100" />
        Teams
      </h1>
      <loading-button text="Team erstellen" icon-name="add" icon-custom-icon func="link" href="/teams/create" class="mb-4 sm:mb-0"/>
    </div>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="w-full" @reset="reset" />
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">Team</th>
            <th class="pb-4 pt-6 px-6">Mitarbeiter</th>
            <th class="pb-4 pt-6 px-6">Optionen</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="team in teams.data" :key="team.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 font-bold" :style="['color: ' + team.color]" :href="`/teams/${team.id}/edit`">
                {{ team.name }}
                <HeroIcon v-if="team.deleted_at" name="trash" icon-mini class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td class="w-40 border-t">
              <Link class="flex items-center px-6" :href="`/teams/${team.id}/edit`" tabindex="-1">
                {{ team.usersCount }}
              </Link>
            </td>
            <td class="w-px border-t px-6" v-if="is_admin">
              <loading-button text="Bearbeiten" icon-name="pencil-square" icon-mini func="link" small inverted :href="`/teams/${team.id}/edit`"/>
            </td>
          </tr>
          <tr v-if="teams.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="4">No teams found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="teams.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import HeroIcon from '@/Shared/HeroIcon.vue'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import LoadingButton from '@/Shared/LoadingButton.vue'

export default {
  components: {
    LoadingButton,
    Head,
    HeroIcon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    teams: Object,
    is_admin: Boolean,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/teams', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
